export default __webpack_public_path__ + "static/media/default-overlay.6d673b01.png";